import React from "react";

const SentimentNeutral = ({fill="#FFDD79", ...props}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <mask
      id="mask0_7522_4722"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={32}
      height={32}
    >
      <rect width={32} height={32} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_7522_4722)">
      <path
        d="M20.6665 14.6667C21.2221 14.6667 21.6943 14.4722 22.0832 14.0833C22.4721 13.6944 22.6665 13.2222 22.6665 12.6667C22.6665 12.1111 22.4721 11.6389 22.0832 11.25C21.6943 10.8611 21.2221 10.6667 20.6665 10.6667C20.1109 10.6667 19.6387 10.8611 19.2498 11.25C18.8609 11.6389 18.6665 12.1111 18.6665 12.6667C18.6665 13.2222 18.8609 13.6944 19.2498 14.0833C19.6387 14.4722 20.1109 14.6667 20.6665 14.6667ZM11.3332 14.6667C11.8887 14.6667 12.3609 14.4722 12.7498 14.0833C13.1387 13.6944 13.3332 13.2222 13.3332 12.6667C13.3332 12.1111 13.1387 11.6389 12.7498 11.25C12.3609 10.8611 11.8887 10.6667 11.3332 10.6667C10.7776 10.6667 10.3054 10.8611 9.9165 11.25C9.52761 11.6389 9.33317 12.1111 9.33317 12.6667C9.33317 13.2222 9.52761 13.6944 9.9165 14.0833C10.3054 14.4722 10.7776 14.6667 11.3332 14.6667ZM12.9998 20.6667H18.9998C19.2887 20.6667 19.5276 20.5722 19.7165 20.3833C19.9054 20.1944 19.9998 19.9556 19.9998 19.6667C19.9998 19.3778 19.9054 19.1389 19.7165 18.95C19.5276 18.7611 19.2887 18.6667 18.9998 18.6667H12.9998C12.7109 18.6667 12.4721 18.7611 12.2832 18.95C12.0943 19.1389 11.9998 19.3778 11.9998 19.6667C11.9998 19.9556 12.0943 20.1944 12.2832 20.3833C12.4721 20.5722 12.7109 20.6667 12.9998 20.6667ZM10.7998 28.2833C9.17761 27.5833 7.7665 26.6333 6.5665 25.4333C5.3665 24.2333 4.4165 22.8222 3.7165 21.2C3.0165 19.5778 2.6665 17.8444 2.6665 16C2.6665 14.1556 3.0165 12.4222 3.7165 10.8C4.4165 9.17778 5.3665 7.76667 6.5665 6.56667C7.7665 5.36667 9.17761 4.41667 10.7998 3.71667C12.4221 3.01667 14.1554 2.66667 15.9998 2.66667C17.8443 2.66667 19.5776 3.01667 21.1998 3.71667C22.8221 4.41667 24.2332 5.36667 25.4332 6.56667C26.6332 7.76667 27.5832 9.17778 28.2832 10.8C28.9832 12.4222 29.3332 14.1556 29.3332 16C29.3332 17.8444 28.9832 19.5778 28.2832 21.2C27.5832 22.8222 26.6332 24.2333 25.4332 25.4333C24.2332 26.6333 22.8221 27.5833 21.1998 28.2833C19.5776 28.9833 17.8443 29.3333 15.9998 29.3333C14.1554 29.3333 12.4221 28.9833 10.7998 28.2833Z"
        fill={fill}
      />
    </g>
  </svg>
);

export default SentimentNeutral;
